// src/pages/FillFormPage.jsx
import React from 'react';
import FormRenderer from '../components/FormRenderer';
import { useParams } from 'react-router-dom';

function FillFormPage() {
  const { id } = useParams();

  return (
    <div>
      <FormRenderer formId={id} />
    </div>
  );
}

export default FillFormPage;
